import React from "react"

import { connect } from "react-redux"

import { Messages } from 'primereact/messages'

import * as appActionCreators from "../../actionCreators/app"

import '../../css/response-display.css'

// response display in it's own component because it needs to connect to the store but
// issues are caused when that is attempted in the App container

// when an ajax response is set in the store than this component is updated
class ResponseDisplay extends React.Component {
  constructor(props) {
    super(props)

    // create references to messages list
    this.messagesList = React.createRef()
  }

  // componentDidUpdate() is invoked immediately after updating occurs. This method is not called for the initial render.
  // since we want to call this.messagesList.current.show which will trigger a render we don't want to do it in the render function itself
  componentDidUpdate(prevProps) {
    let previousAjaxResponse = prevProps.app.ajaxResponse
    let ajaxResponse = this.props.app.ajaxResponse

    // only display message if the response has changed and there is a response
    if (previousAjaxResponse !== ajaxResponse && ajaxResponse) {
      if (ajaxResponse.data) {
        // shouldn't need to set state like this but using the clear function on the primereact component doesn't allow
        // something to be called once the state has been set to clear the messages so what was happening was that the messages
        // still existed when showing the new message so nothing gets cleared
        this.messagesList.current.setState({
          messages: []
        }, () => { this.showNewMessage(ajaxResponse) })
      } else {
        // clear any messages if the message was cleared in the store
        this.messagesList.current.clear()
      }
    }
  }

  showNewMessage = ajaxResponse => {
    // check if the response is successful i.e. successfully saved
    if (ajaxResponse.data.Success) {
      let successMessage = ajaxResponse.data.SuccessMessage ? ajaxResponse.data.SuccessMessage : "record saved successfully"
      this.messagesList.current.show({ severity: 'success', summary: successMessage, detail: '', life: 15000 })
    }
    else {
      let errors = ajaxResponse.data.ErrorMessages ? ajaxResponse.data.ErrorMessages.$values : []
      // build up a list of errors
      let listOfErrors = <ul>{errors.map((error, index) => <li key={index}>{error}</li>)}</ul>

      // set sticky to true so the user must close otherwise it will close automatically
      this.messagesList.current.show({ sticky: true, severity: 'error', summary: '', detail: listOfErrors })
    }
  }

  render() {
    // className set so the messages is fixed position to appear over header and overlays
    // ref used so that the show can be triggered by reference
    // when message is closed clear the response in the store
    return <Messages className={"response-message"} ref={this.messagesList} onRemove={this.props.clearAjaxResponse}></Messages>
  }
}

const mapStateToProps = (state) => {
  return state
}

export default connect(mapStateToProps, appActionCreators)(ResponseDisplay);


// WEBPACK FOOTER //
// ./src/components/common/ResponseDisplay.js